<!-- Map container -->
<div #map class="map-wraper" [style.width]="width" [style.height]="height"></div>

<!-- Floating controls -->
<ng-container *ngIf="mapLoaded">
  <ng-container *ngIf="editMode">

    <!-- Top Left Controls -->
    <div #topLeftControlsWrapper class="top-left-controls-wrapper">
      <div #searchControlBtnWrapper *ngIf="showSearchButton">
        <app-search-field
          #searchControl
          [map]="gmap"
          [enableAddressSearch]="true"
          [enableWhat3WordSearch]="true"
          [enableZonesAreasSearch]="true"
          [enableVenueMapsSearch]="true"
          [zones]="zones"
          [areas]="areas"
          [venueMaps]="venueMaps"
          [enableZonesAreasSearch]="enableZonesAreasSearch"
          (searchStateChanged)="onSearchStateChanged($event)"
          (autocompleteResult)="onAutocompleteResult($event)"
          (what3WordsResult)="onWhat3WordsResult($event)"
        >
        </app-search-field>
      </div>
      <div *ngIf="showMyLocationButton && !isMobile" #myLocationControlBtnWrapper>
        <app-my-location-button (locationAvailableEvent)="onMyLocationAvailable($event)"></app-my-location-button>
      </div>
      <div *ngIf="showNoLocationButton && lat && lng" #noLocationControlBtnWrapper>
        <app-no-location-button (onClickedEvent)="setNoLocation()"></app-no-location-button>
      </div>
    </div>

    <!-- Top Center Controls -->
    <div #topCenterControlsWrapper *ngIf="isMobile">
      <div *ngIf="showMyLocationButton" #myLocationControlBtnWrapper>
        <app-my-location-button
          [showLabel]="true"
          (locationAvailableEvent)="onMyLocationAvailable($event)"
        ></app-my-location-button>
      </div>
    </div>
  </ng-container>

  <!-- Top Right Controls -->
  <div #zoneAreaControlBtnWrapper
    class="top-right-controls-wrapper"
    [ngClass]="{ 'top-right-controls-wrapper': !isMobile, 'mobile-wrapper': isMobile }"
  >
    <app-zone-area-toggle-button *ngIf="showZonesAndAreasButton && polygonsAvailable"
      [map]="gmap"
      [zonesPolygon]="zonesPolygon"
      [areasPolygon]="areasPolygon">
    </app-zone-area-toggle-button>
    <app-venue-maps-toggle-button *ngIf="venueMapsEnabled"
      [map]="gmap"
      [venueMaps]="venueMaps"
      [groundOverlays]="groundOverlays"
      [tileOverlays]="tileOverlays"
    ></app-venue-maps-toggle-button>
  </div>

  <!-- Bottom Right Controls -->
  <div #w3wGridControlBtnWrapper *ngIf="showW3WGridButton"
    class="bottom-right-controls-wrapper">
      <app-w3w-grid-button
        [map]="gmap"
        (clicked)="onW3WGridControlClicked($event)"
        (gridToggled)="onW3WGridToggled($event)">
      </app-w3w-grid-button>
  </div>

  <!-- Bottom Center Controls -->
  <div #mapTypesBtnWrapper
    class="map-types-control-wrapper">
      <app-map-views-group-button #mapTypesGroupButton
        [map]="gmap"
        [drawAsMapOverlay]="true">
      </app-map-views-group-button>
  </div>

</ng-container>
